
























































/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCardMax from "@/Ui-Components/Common/Container/ParticaCardMax.vue";

import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ListItemDTO, StoreArticleDTO, ArticleModel, CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import { ButtonConfig, ButtonStatus, ButtonType } from "../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import { INavigationService } from "../../NavigationServices/navigation";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import { IArticle, Article, ArticleImage } from "../../Models/ArticleModels/article";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import SimpleArticleView from "../../Ui-Components/Article/SimpleView/SimpleArticleView.vue";
import ParticaArticleEdit from "../../Ui-Components/Article/Edit/ParticaArticleEdit.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
@Component(
	{
		name: "PurchasedArticles",
		components: {
			SimpleArticleView,
			ParticaCard,
			ParticaView,
			ParticaArticlePreview,
			ParticaRowContainer,
			ParticaArticleEdit,
			ParticaCardMax,
			ParticaRightDrawer
		}
	})
export default class PurchasedArticles extends ParticaAccountBase {
	@Prop() private id: number;

	private store: IParticaStoreService;
	private svc: INavigationService;
	private data: IArticle[] = [];
	private showpreviewarticle: boolean = false;
	private showeditarticle: boolean = false;
	private currentarticle: IArticle = new Article() as IArticle;
	private licence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private showlicence: boolean = false;

	private buttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ARTICLE_SAVE, label: "Save Article", status: ButtonStatus.Disabled, type: ButtonType.OK } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.SELECT_ARTICLE_LICENCE: {
					this.licence = await this.store.getArticleLicence(event.item.articleId);
					this.showlicence = true;
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					this.currentarticle = await this.store.getPurchasedArticle(event.item.articleId);
					this.showpreviewarticle = true;
					break;
				}
				case eParticaAction.ARTICLE_EDIT: {
					this.buttons[0].status = ButtonStatus.Disabled;
					this.currentarticle = await this.store.getPurchasedArticle(event.item.articleId);
					this.showeditarticle = true;
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.currentarticle = await this.store.savePurchasedArticle(this.currentarticle);
					this.ShowSnackbar(`Saved '${this.currentarticle.title}'`);
					this.buttons[0].status = ButtonStatus.Disabled;
					await this.init();
					break;
				}
				case eParticaAction.PROPERTY_CHANGED: {
					this.buttons[0].status = ButtonStatus.Enabled;
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Purchased Articles";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.svc = this.particaServices.getNavigationService();
			this.store = this.particaServices.getParticaStoreService();
			await this.getAccountNav(this.id);
			this.data = await this.store.getPurchasedArticles(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}
}
